exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drop-zone {\n  margin: auto;\n  height: 100px;\n  border: 2px dotted #0782d0;\n  border-radius: 30px; }\n\n.content {\n  color: #0782d0;\n  height: 100px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\n.over {\n  background-color: rgba(147, 147, 147, 0.5); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/~/ngx-file-drop/lib/ngx-drop/file-drop.component.scss
// module id = ../../../../ngx-file-drop/lib/ngx-drop/file-drop.component.scss
// module chunks = 11